import type { IconProps } from '../types';

const Eye = (props: IconProps) => (
  <svg
    fill="#7A7A98"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path d="M16 24.5c-6.503 0-11.636-7.425-11.807-7.7-.257-.275-.257-.733 0-1.1C4.363 15.425 9.497 8 16 8s11.636 7.425 11.808 7.7c.256.275.256.733 0 1.1-.172.275-5.305 7.7-11.808 7.7zM5.99 16.25c1.283 1.65 5.304 6.417 10.01 6.417 4.706 0 8.813-4.767 10.01-6.417C24.728 14.6 20.707 9.833 16 9.833c-4.706 0-8.813 4.767-10.01 6.417z" />
    <path d="M16 20.834c-2.738 0-4.889-2.017-4.889-4.584 0-2.566 2.151-4.583 4.89-4.583 2.737 0 4.889 2.017 4.889 4.583 0 2.567-2.152 4.584-4.89 4.584zm0-7.334c-1.662 0-2.933 1.192-2.933 2.75S14.338 19 16 19c1.663 0 2.934-1.192 2.934-2.75S17.663 13.5 16 13.5z" />
  </svg>
);

export default Eye;
